import { render } from "./UserReports.vue?vue&type=template&id=7e78945a&scoped=true"
import script from "./UserReports.vue?vue&type=script&lang=js"
export * from "./UserReports.vue?vue&type=script&lang=js"

import "./UserReports.vue?vue&type=style&index=0&id=7e78945a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e78945a"]])

export default __exports__